import { MarcacaoPK } from "../marcacao/marcacao-procedimento/pks/marcacao-pk";
import { InformacaoCancelamentoMarcacaoDTO } from "./informacao-cancelamento-marcacao-dto";

export class InformacaoCancelamentoMarcacaoProcedimentoDTO extends InformacaoCancelamentoMarcacaoDTO {

    pkMarcacao: MarcacaoPK | undefined;

}
